import { Box, Typography, styled } from '@mui/material';

export const SelectWrapper = styled(Box)(() => ({
	position: 'relative',
	width: '100%',
}));

export const SelectedCard = styled(Box)(() => ({
	display: 'flex',
	alignItems: 'center',
	gap: '12px',
	padding: '8px',
	borderRadius: '20px',
	width: '100%',
	cursor: 'pointer',
	background: '#f3f7fb',
	transition: 'transform 150ms ease, box-shadow 150ms ease',
	boxShadow: '5px 8px 15px -10px rgba(16, 39, 75, 0.4)',

	'&:active': {
		transform: 'scale(0.99)',
		boxShadow: '0px 12px 32px -16px rgba(16, 39, 75, 0.32)',
	},
}));

export const SelectedContent = styled(Box)({
	display: 'flex',
	flexDirection: 'column',
	gap: '4px',
	minWidth: 0,
});

export const ChildLabel = styled(Typography)(({ theme }) => ({
	color: theme.palette.text.secondary,
	fontWeight: 500,
	lineHeight: 1.2,
}));

export const NameRow = styled(Box)(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	gap: '6px',
	color: theme.palette.text.primary,
	'& .MuiTypography-root': {
		fontWeight: 700,
		lineHeight: 1.2,
	},
}));

export const ArrowIcon = styled(Box, {
	shouldForwardProp: (prop) => prop !== '$open',
})<{ $open?: boolean }>(({ $open }) => ({
	display: 'flex',
	alignItems: 'center',
	transition: 'transform 150ms ease',
	transform: $open ? 'rotate(180deg)' : 'rotate(0deg)',
}));

export const Dropdown = styled(Box)(({ theme }) => ({
	position: 'absolute',
	top: 'calc(100% + 10px)',
	left: 0,
	right: 0,
	display: 'flex',
	flexDirection: 'column',
	gap: '10px',
	padding: '8px',
	borderRadius: '16px',
	background: theme.palette.common.white,
	boxShadow: '0px 24px 44px -18px rgba(16, 39, 75, 0.35)',
	zIndex: 5,
}));

export const StudentItem = styled(Box)(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	gap: '12px',
	padding: '8px',
	borderRadius: '12px',
	cursor: 'pointer',
	background: theme.palette.common.white,
	transition: 'transform 120ms ease, box-shadow 120ms ease, background 120ms ease',
	boxShadow: '5px 8px 15px -10px rgba(16, 39, 75, 0.28)',
	'&[data-selected="true"]': {
		background: 'linear-gradient(180deg, #f7f9fd 0%, #eef3fa 100%)',
		boxShadow: '5px 8px 15px -10px rgba(16, 39, 75, 0.4)',
	},
	'&:active': {
		transform: 'scale(0.99)',
	},
}));

export const StudentName = styled(Typography)(({ theme }) => ({
	color: theme.palette.text.primary,
	fontWeight: 700,
	lineHeight: 1.3,
}));

export const StudentMeta = styled(Typography)(({ theme }) => ({
	color: theme.palette.text.secondary,
	fontSize: '14px',
	lineHeight: 1.3,
}));
